"use client";
import React from "react";
// import Button from "src/app/components/ui/Button";

interface SwitchProps {
  button1Text: string;
  button2Text: string;
  disable?: 0 | 1 | 2;
  activeState: 1 | 2;
  onSwitch: (newState: 1 | 2) => void;
}

const Switch: React.FC<SwitchProps> = ({
  button1Text,
  button2Text,
  activeState,
  onSwitch,
  disable,
}) => {
  const handleButton1Click = () => {
    if (disable !== 1) onSwitch(1);
  };

  const handleButton2Click = () => {
    if (disable !== 2) onSwitch(2);
  };

  return (
    <div className="flex gap-2">
      <h2
        onClick={handleButton1Click}
        className={`!px-10 h6 py-3 ${
          disable === 1
            ? "!pointer-events-none !cursor-not-allowed"
            : "cursor-pointer"
        } rounded ${
          activeState === 1
            ? "bg-themeColor !text-white"
            : "bg-white !text-themeColor"
        }`}
      >
        {button1Text}
      </h2>
      <h2
        onClick={handleButton2Click}
        className={`!px-10 h6 py-3 ${
          disable === 2
            ? "!pointer-events-none !cursor-not-allowed"
            : "cursor-pointer"
        } rounded ${
          activeState === 2
            ? "bg-themeColor !text-white"
            : "bg-white !text-themeColor"
        }`}
      >
        {button2Text}
      </h2>
    </div>
  );
};

export default Switch;

interface SwitchProps {
  button1Text: string;
  button2Text: string;
  activeState: 1 | 2; // Prop to receive the active state from parent
  onSwitch: (newState: 1 | 2) => void; // Callback to update parent state
}

export const Switch2: React.FC<SwitchProps> = ({
  button1Text,
  button2Text,
  activeState,
  onSwitch,
  disable,
}) => {
  const handleButton1Click = () => {
    if (disable !== 1) onSwitch(1);
  };

  const handleButton2Click = () => {
    if (disable !== 2) onSwitch(2);
  };

  return (
    <div className="flex  flex-1 relative gap-2">
      <div className="w-full absolute bottom-0 z-[10] h-1 !bg-[rgba(var(--primary-color-rgb),0.1)]"></div>
      <h2
        onClick={handleButton1Click}
        className={`!px-6 cursor-pointer relative py-2 h6  rounded rounded-b-none ${
          activeState === 1
            ? "!bg-[rgba(var(--primary-color-rgb),0.1)] !text-themeColor"
            : "bg-white !text-themeColor"
        }`}
      >
        {activeState === 1 && (
          <div className="absolute bottom-0 left-0 w-full bg-themeColor h-1"></div>
        )}

        {button1Text}
      </h2>
      <h2
        onClick={handleButton2Click}
        className={`!px-6 cursor-pointer h6 py-2 relative ${
          disable === 2 && "cursor-not-allowed"
        }  rounded-b-none rounded ${
          activeState === 2
            ? "!bg-[rgba(var(--primary-color-rgb),0.1)] !text-themeColor"
            : "bg-white !text-themeColor"
        }`}
      >
        {activeState === 2 && (
          <div className="absolute bottom-0 left-0 w-full bg-themeColor h-1"></div>
        )}
        {button2Text}
      </h2>
    </div>
  );
};
